import { render, staticRenderFns } from "./LightBoxConfirm.vue?vue&type=template&id=339b0d16&"
import script from "./LightBoxConfirm?vue&type=script&lang=ts&"
export * from "./LightBoxConfirm?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports